import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const MainPage = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1400px;
  box-sizing: border-box;
  padding: 29px;
`;

function MainContent({ children }) {
  return <MainPage> {children} </MainPage>;
}

export default MainContent;

MainContent.propTypes = {
  children: PropTypes.element.isRequired,
};
